<nav aria-label="Page navigation example" class="list-pagination">
    <ul class="pagination mb-2 mb-sm-0">
      <li class="page-item">
        <a class="page-link tex" href="#" (click)="pageChange(page > 1 ? page - 1 : 1); $event.preventDefault()">
          <i class="fa-solid fa-angle-left"></i>
        </a>
      </li>
      
      <li *ngFor="let p of getPagesToDisplay(); let i = index; trackBy: trackByFn" class="page-item">
        <a 
          class="page-link" 
          href="#" 
          (click)="pageChange(p); $event.preventDefault()" 
          [ngClass]="{'active': p === page}">
          {{ p }}
        </a>
      </li>
      
      <li class="page-item">
        <a class="page-link tex" href="#" (click)="pageChange(page < totalPage ? page + 1 : totalPage); $event.preventDefault()">
          <i class="fa-solid fa-angle-right"></i>
        </a>
      </li>
    </ul>
  </nav>